import { useIcs204aVersions } from 'components/IAP/hooks/assignmentListHooks';
import Ics204SignatureProgressRing from './Ics204SignatureProgressRing';
import { parseWalaSignatures } from './ics204aSignatureSlots';

type Ics204aButtonSignatureProgressProps = {
  walaId: string | null | undefined;
  plannedResourceKey: string;
};

/**
 * Tip-driven signature progress for the planned-resource 204A button. Reuses
 * the same ring as ICS-204 (hidden while unsigned/draft).
 */
const Ics204aButtonSignatureProgress = ({
  walaId,
  plannedResourceKey,
}: Ics204aButtonSignatureProgressProps) => {
  const { data: versions = [] } = useIcs204aVersions(
    walaId ?? '',
    plannedResourceKey
  );
  const tip = versions.length > 0 ? versions[versions.length - 1] : undefined;
  const tipSignatures = parseWalaSignatures(tip?.signatures);

  return (
    <Ics204SignatureProgressRing
      signatures={tipSignatures}
      size={16}
      testId="ics204a-button-signature-progress-ring"
      triggerAs="span"
    />
  );
};

export default Ics204aButtonSignatureProgress;
